document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".form__step").forEach(form => {
        const formId = form.id;
        const nextButton = form.querySelector(".btn-nav_next");
        const radioInputs = form.querySelectorAll("input[type='radio']");
        const answerKey = `answer_${formId}`;
        
        const savedAnswer = localStorage.getItem(answerKey);
        if (savedAnswer) {
            const selectedInput = form.querySelector(`input[value='${savedAnswer}']`);
            if (selectedInput) {
                selectedInput.checked = true;
                nextButton.classList.remove("btn_disabled");
            }
        } else {
            nextButton.classList.add("btn_disabled");
        }
        
        radioInputs.forEach(input => {
            const questionId = input.dataset.questionId;
            input.addEventListener("change", () => {
                localStorage.setItem(`question_${formId}`, questionId);
                localStorage.setItem(answerKey, input.value);
                nextButton.classList.remove("btn_disabled");
            });
        });
    });
});
